import styled, { keyframes } from 'styled-components';

const SkeletonLoader = () => {
  return (
    <LoadingCard>
      <LoadingLogo />
      <LoadingTextBlock>
        <LoadingText />
        <LoadingText short />
      </LoadingTextBlock>
    </LoadingCard>
  );
};

export default SkeletonLoader;

// Skeleton Loader Styles

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const LoadingLogo = styled.div`
  width: 100%;
  aspect-ratio: 1;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
`;

const LoadingTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const LoadingText = styled.div<{ short?: boolean }>`
  height: 12px;
  width: ${({ short }) => (short ? '60%' : '100%')};
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
`;

const LoadingCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
  min-width: 140px;
  max-width: 400px;
  aspect-ratio: 1;
  border-radius: 8px;

  ${LoadingLogo}, ${LoadingText} {
    animation: ${shimmer} 1.5s infinite linear;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.12) 25%,
      rgba(255, 255, 255, 0.1) 50%
    );
    background-size: 200% 100%;
  }
`;
